/**
 * Fetches the current user's administration permission for the knowledge center
 */

import { queryOptions } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

function fetchCanAdmin () {
  return queryOptions({
    queryKey: ['fetchCanAdmin'],
    queryFn: () => (
      fetch('/KnowledgeCenter/admin')
        .then(decodeJson)
        .catch(({ body, status }) => {
          throw new ApiError('Unable to determine if the current user can administrate the Knowledge Center.', body, status);
        })
    )
  });
}

export default fetchCanAdmin;
